import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React, { PropsWithChildren } from 'react';

interface CustomizedAccordionProps {
  name: string;
  expanded: string | false;
  handleChange: (a: string) => any;
  width?: string;
}

export default function CustomizedAccordion(
  props: PropsWithChildren<CustomizedAccordionProps>
) {
  const Detail = () => {
    return <></>;
  }; //props.detail;

  return (
    <div>
      <Divider sx={{}} flexItem role='presentation' color='black'></Divider>
      <MuiAccordion
        elevation={0}
        expanded={props.expanded === props.name}
        onChange={props.handleChange(props.name)}
      >
        <MuiAccordionSummary
          aria-controls='panel1d-content'
          id={props.name}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              justifyContent: 'left',
              alignItems: 'left',
            }}
          >
            {props.name}
          </Typography>
        </MuiAccordionSummary>
        <MuiAccordionDetails>{props.children}</MuiAccordionDetails>
      </MuiAccordion>
    </div>
  );
}
